import { scrollAnimataion } from './scroll-animataion/scroll-animataion.js';
import { markerSet } from './marker-set/marker-set.js';
import { fadeJudge } from './to-top-btn-fade/to-top-btn-fade.js';


// ===========================================
// 中見出しのインタラクション
// ===========================================
$(function () {
  markerSet( $('.interview') );

  $(window).on('scroll', function(){
    markerSet( $('.interview') );
  });
});


// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimataion({
  className: "interview",
  triggerPoint: 200,
});


// ===========================================
// ページ上部へ戻るボタンのインタラクション
// ===========================================
$(function () {
  fadeJudge();
});